import { FC } from 'react';
import { StatsModal } from '../StatsModal';
import type { useMessagesGQL } from '../../../../hooks/graphql/dashboard/useMessagesGQL';
import { buildEmailColumns } from './emailColumns';

type EmailEngagementKind = 'open' | 'click' | null;

interface Props {
  /** `null` = modal closed, `'open'` / `'click'` = open with that title. */
  kind: EmailEngagementKind;
  onClose: () => void;
  dateRange: { from: Date | null; to: Date | null };
  onDateRangeChange?: (range: { from: Date | null; to: Date | null }) => void;
  timezone?: string;
  emailEngagementGQL: ReturnType<typeof useMessagesGQL>;
  onOpenContact: (contactId: string) => void;
}

/**
 * Email Engagement drill-down — same row shape as EmailsStatsModal,
 * just titled "Email Opens" or "Email Clicks" depending on which widget
 * tile fired it. Column factory is shared via emailColumns.
 */
export const EmailEngagementStatsModal: FC<Props> = ({
  kind,
  onClose,
  dateRange,
  onDateRangeChange,
  timezone,
  emailEngagementGQL,
  onOpenContact,
}) => {
  if (!kind) return null;
  return (
    <StatsModal
      isOpen={!!kind}
      onClose={onClose}
      title={kind === 'open' ? 'Email Opens' : 'Email Clicks'}
      dateRange={dateRange}
      onDateRangeChange={onDateRangeChange}
      currentPage={emailEngagementGQL.currentPage}
      pageSize={emailEngagementGQL.pageSize}
      onNextPage={emailEngagementGQL.nextPage}
      onPrevPage={emailEngagementGQL.prevPage}
      onPageChange={emailEngagementGQL.goToPage}
      onPageSizeChange={emailEngagementGQL.changePageSize}
      totalCount={emailEngagementGQL.total}
      isLoading={emailEngagementGQL.isLoading}
      columns={buildEmailColumns({ timezone, onOpenContact })}
      data={emailEngagementGQL.items || []}
    />
  );
};

export default EmailEngagementStatsModal;
